/**
 * Returns the full path to the settings page of a Battery-Configuration-Setting to a specific installation
 * @param installationId The ID (serial number) of the actual installation
 * @param storageId The ID (serial number) of the related device
 * @param listIndex Batteries linked to a device are referenced by the list index, associated to the list of
 * batteries linked to the related device
 * @param url
 */
export const getDetailsRoute = (
  installationId = ':installationId',
  storageId = ':storageId',
  batteryIndex: string | number = ':batteryIndex',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/battery`
  }

  return `/installation/${installationId}/${storageId}/properties/battery/${batteryIndex}`
}

export const getFarmDetailsRoute = (
  installationId = ':installationId',
  storageId = ':storageId',
  childStorageId = ':childStorageId',
  batteryIndex: string | number = ':batteryIndex',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/battery`
  }

  return `/installation/${installationId}/${storageId}/properties/battery/${childStorageId}/${batteryIndex}`
}

/**
 * Returns the generic starting point for any Battery-Configuration-Setting of a specific installation
 *
 * This route is used in cases when it is unknown which battery list index should be called
 *
 * TODO: this will be deprecated as soon as the battery-settings also uses the nested route pattern
 *
 * @param installationId The ID (serial number) of the actual Installation
 * @param storageId The ID (serial number) of the related device
 * @param url
 */
export const getBatteriesDispatchRoute = (installationId: string | number = ':installationId', storageId = ':storageId', url?: string): string => {
  if (url) {
    return `${url}/properties/battery`
  }
  return `/installation/${installationId}/${storageId}/properties/battery`
}
